// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/" + chunkId + "." + {"381": "123d567d","890": "cce9f073",}[chunkId] + ".css"
}